module.exports = __webpack_public_path__ + "media/images/admin/default-avatar-ed769a26a8d56a5b6ec4bce54042a15e.png";